var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _circle, _circle2, _circle3, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 287,
    viewBox: "0 0 386 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.8596,
    y: 48.3926,
    width: 257.407,
    height: 188.992,
    stroke: "#C6C6C6",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.832031,
    width: 268.26,
    height: 202.564,
    fill: "#F1F1F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.06958,
    y: 30.3955,
    width: 255.121,
    height: 168.621,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8734,
    y: 52.2949,
    width: 211.323,
    height: 122.633,
    rx: 8,
    fill: "#F1F1F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244.672,
    y: 13.9717,
    width: 16.4241,
    height: 4.37976,
    rx: 2.18988,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 91.1016,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 138.612,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 138.727,
    y: 91.1016,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "#4D69E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 83.5,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 131.011,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "#819DFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138.727,
    y: 83.5,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 98.7031,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 146.214,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "#819DFF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 138.727,
    y: 98.7031,
    width: 78.8672,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 106.305,
    width: 44.6598,
    height: 4.75104,
    rx: 2.37552,
    fill: "#4D69E9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7061,
    y: 153.815,
    width: 44.6598,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 138.727,
    y: 106.305,
    width: 44.6598,
    height: 4.75104,
    rx: 2.37552,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.80693,
    cy: 15.6133,
    r: 2.73735,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.4716,
    cy: 15.6133,
    r: 2.73735,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1362,
    cy: 15.6133,
    r: 2.73735,
    fill: "#C4C4C4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_660_6299)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.582,
    y: 120.559,
    width: 198.883,
    height: 134.678,
    rx: 15,
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 202.19,
    y1: 188.483,
    x2: 321.167,
    y2: 188.483,
    stroke: "#F1F1F1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 211.466,
    x2: 319.467,
    y2: 211.466,
    stroke: "#F1F1F1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 176.991,
    x2: 319.467,
    y2: 176.991,
    stroke: "#F1F1F1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 199.975,
    x2: 319.467,
    y2: 199.975,
    stroke: "#F1F1F1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 200.49,
    y1: 165.499,
    x2: 319.467,
    y2: 165.499,
    stroke: "#F1F1F1"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 209.489,
    y1: 154.507,
    x2: 209.489,
    y2: 218.43,
    stroke: "#F1F1F1"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 250.281,
    y1: 154.507,
    x2: 250.281,
    y2: 218.43,
    stroke: "#F1F1F1"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 291.073,
    y1: 154.507,
    x2: 291.073,
    y2: 218.43,
    stroke: "#F1F1F1"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 223.086,
    y1: 153.789,
    x2: 223.086,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 263.878,
    y1: 153.789,
    x2: 263.878,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 304.67,
    y1: 153.789,
    x2: 304.67,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 236.683,
    y1: 153.789,
    x2: 236.683,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 277.475,
    y1: 153.789,
    x2: 277.475,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 318.267,
    y1: 153.789,
    x2: 318.267,
    y2: 217.712,
    stroke: "#F1F1F1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 185.287,
    y: 155.716,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 186.237,
    y: 212.729,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 185.287,
    y: 184.222,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 197.64,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 197.64 235.533)",
    fill: "#E0DBFF"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 226.146,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 226.146 235.533)",
    fill: "#E0DBFF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 254.652,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 254.652 235.533)",
    fill: "#E0DBFF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 283.158,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 283.158 235.533)",
    fill: "#E0DBFF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 311.665,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 311.665 235.533)",
    fill: "#E0DBFF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 185.287,
    y: 169.969,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 186.237,
    y: 226.981,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 185.287,
    y: 198.476,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    fill: "#E0DBFF"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 211.893,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 211.893 235.533)",
    fill: "#E0DBFF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 240.399,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 240.399 235.533)",
    fill: "#E0DBFF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 268.905,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 268.905 235.533)",
    fill: "#E0DBFF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 297.412,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 297.412 235.533)",
    fill: "#E0DBFF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 325.918,
    y: 235.533,
    width: 5.70124,
    height: 2.85062,
    rx: 1.42531,
    transform: "rotate(-90 325.918 235.533)",
    fill: "#E0DBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.01 195.15C230.167 183.004 207.911 207.003 200.245 221.764C199.906 222.416 200.388 223.181 201.123 223.181H321.117C321.669 223.181 322.117 222.733 322.117 222.181V157.746C322.117 156.557 320.085 156.273 319.699 157.397C312.505 178.307 294.626 206.137 264.01 195.15Z",
    fill: "#738CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190.038 148.114V232.683H332.094",
    stroke: "#E0DBFF",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_660_6299",
    x: 144.582,
    y: 109.559,
    width: 240.883,
    height: 176.678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.700272 0 0 0 0 0.700272 0 0 0 0 0.700272 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_660_6299"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_660_6299",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.84cdd64d380e6bf6435e31471c54bf68.svg";
export { ForwardRef as ReactComponent };